import { render, staticRenderFns } from "./ConnectedPeopleIcon.vue?vue&type=template&id=5f053e36"
import script from "./ConnectedPeopleIcon.vue?vue&type=script&lang=js"
export * from "./ConnectedPeopleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports